import { Component, computed, Input, OnChanges, signal, Signal, SimpleChanges, WritableSignal } from '@angular/core';
import { AreasWithBatchStock, AreasWithStock, AreaWithBatchStock, AreaWithStock, CompaniesWithBatchStocks, CompaniesWithStoreStocks, CompanyWithBatchStocks } from 'src/app/models/types/Product/Stock.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { HqStockComponent } from '../hq-stock/hq-stock.component';
import { HqBatchStockComponent } from '../hq-batch-stock/hq-batch-stock.component';
import { PdpService } from '../../pdp.service';

@Component({
  selector: 'app-global-hq-stock',
  imports: [SharedModule, HqStockComponent, HqBatchStockComponent],
  templateUrl: './global-hq-stock.component.html',
  styleUrl: './global-hq-stock.component.scss'
})
export class GlobalHqStockComponent implements OnChanges {

  @Input('sapCode') sapCode!: string;
  // @Input('globalHqStock') globalHqStock!: AreasWithStock | AreasWithBatchStock | null;

  // private _selectedArea: WritableSignal<AreaWithStock | AreaWithBatchStock | null> = signal(null);
  // public selectedArea: Signal<AreaWithStock | AreaWithBatchStock | null> = computed(() => this._selectedArea());

  public selectedCompaniesWithStock: Signal<CompaniesWithStoreStocks> = computed(() => {
    return this.pdpService.selectedCompaniesWithStock();
  });

  public selectedCompaniesWithBatchStock: Signal<CompaniesWithBatchStocks> = computed(() => {
    return this.pdpService.selectedCompaniesWithBatchStock();
    // let area = this.pdpService.selectedArea();
    // if (!area) return [];

    // if ('companiesWithBatchStock' in area) {
    //   return area.companiesWithBatchStock.filter(company => company !== null);
    // }

    // return [];
  });

  constructor(
    public pdpService: PdpService
  ) { }

  isLoadingArea(area: AreaWithStock | AreaWithBatchStock | null): boolean {
    let companies: any[] = [];

    if (!area) return false;

    if ('companiesWithStock' in area) {
      companies = area.companiesWithStock;
    }
    if ('companiesWithBatchStock' in area) {
      companies = area.companiesWithBatchStock;
    }

    return companies ? companies.some(company => company === null) : false;
  }

  isBatchManaged(area: AreaWithStock | AreaWithBatchStock): boolean {
    return area && 'companiesWithBatchStock' in area;
  }

  handleSelectArea(area: AreaWithStock | AreaWithBatchStock | null, index: number) {
    // this._selectedArea.set(area);
    this.pdpService.handleSelectArea(index);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (this.selectedArea()) {
    // this._selectedArea.set(this.globalHqStock?.find(area => area.description === this.selectedArea()?.description) || null);
    // }
  }

}
